const translations = {
    en: {
        welcome: {
            hello: "Hi, ${ firstName }",
            hello_hotel_context: "Welcome to <br/>${hotel}",
            here_your_reservation: "Here's your reservation",
            fb_chat_button: "Chat now!",
            whatsapp_chat_button: "Chat now!"
        }
    },
    de: {
        welcome: {
            hello: "Hallo, ${ firstName }",
            hello_hotel_context: "Wilkommen im <br/>${hotel}",
            here_your_reservation: "Hier ist Ihre Reservierung",
            fb_chat_button: "Jetzt chatten!",
            whatsapp_chat_button: "Jetzt chatten!"
        }
    },
    es: {
        welcome: {
            hello: "Hola, ${ firstName }",
            hello_hotel_context: "Bienvenido a <br/>${hotel}",
            here_your_reservation: "Aqui està su reserva",
            fb_chat_button: "Chatea ahora!",
            whatsapp_chat_button: "Chatea ahora!"
        }
    },
    fr: {
        welcome: {
            hello: "Salut, ${ firstName }",
            hello_hotel_context: "Bienvenue au <br/>${hotel}",
            here_your_reservation: "Voici votre réservation",
            fb_chat_button: "Bavardez maintenant!",
            whatsapp_chat_button: "Bavardez maintenant!"
        }
    },
    it: {
        welcome: {
            hello: "Ciao, ${ firstName }",
            hello_hotel_context: "Benvenuto al <br/>${hotel}",
            here_your_reservation: "Ecco la tua prenotazione",
            fb_chat_button: "Chatta ora!",
            whatsapp_chat_button: "Chatta ora!"
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/welcome/Welcome.js